<script setup lang="ts">
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { Stop } from '@/types'

const props = withDefaults(
  defineProps<{
    stop?: Stop
    routeCodes?: string[]
  }>(),
  { routeCodes: () => [] },
)

const open = defineModel<boolean>('open', { default: false })
const emit = defineEmits<{ viewBuses: [stopId: number] }>()
</script>

<template>
  <Dialog v-model:open="open">
    <DialogContent>
      <DialogHeader>
        <DialogDescription>Bus stop</DialogDescription>
        <DialogTitle>{{ props.stop?.name }}</DialogTitle>
      </DialogHeader>

      <div class="border-y py-3">
        <p class="text-xs label-uppercase text-muted-foreground">Passing routes</p>
        <p v-if="props.routeCodes.length > 0" class="mt-1 text-xs text-popover-foreground">
          {{ props.routeCodes.join(', ') }}
        </p>
        <p v-else class="mt-1 text-xs text-popover-foreground">No route information available.</p>
      </div>

      <DialogFooter>
        <Button v-if="props.stop" type="button" @click="emit('viewBuses', props.stop.id)">
          View buses
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
